import { useTranslation } from "../LanguageContext";

function NotFound() {
    const { t } = useTranslation();
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-primary-50 flex flex-col items-center justify-center px-4">
            <h1 className="text-8xl font-extrabold text-primary-600 mb-4">404</h1>
            <h3 className="text-2xl font-bold text-slate-800 mb-2">{t('notfound.title')}</h3>
            <p className="text-slate-500 mb-8">{t('notfound.desc')}</p>
            <a href="/" className="btn-primary">
                {t('notfound.home')}
            </a>
        </div>
    );
}

export default NotFound;
